class WhatToExpectSlider extends HTMLElement {
  constructor () {
    super();
    this.swiper = null;
  }

  connectedCallback () {
    this.swiperEl = this;
    this.pagination = this.querySelector('.swiper-pagination');
    this.initSwiper();
  }

  initSwiper () {
    if (!this.swiperEl) return;

    const initOrDestroy = () => {
      const isMobile = window.matchMedia('(max-width: 749px)').matches;

      if (isMobile && !this.swiper) {
        this.swiper = new Swiper(this.swiperEl, {
          slidesPerView: 2,
          centeredSlides: false,
          spaceBetween: 40,
          pagination: {
            el: this.pagination,
            clickable: true
          },
          breakpoints: {
            500: {
              slidesPerView: 'auto',
              centeredSlides: true,
            }
          }
        });
      } else if (!isMobile && this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    };

    initOrDestroy();
    window.addEventListener('resize', initOrDestroy);
  }

  disconnectedCallback() {
    if (this.swiper && !this.swiper.destroyed) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

if (!customElements.get('what-to-expect-slider')) {
  customElements.define('what-to-expect-slider', WhatToExpectSlider)
}
